module.exports = __webpack_public_path__ + "img/old-wild-west.595353bc.png";